export default __webpack_public_path__ + "static/media/light_frezer.9926df02.svg";